<template>
  <b-card class="shadow-sm">
    <b-card-title class="mb-2 px-6 pt-6">
      <div>
        <b-icon icon="exclamation-circle-fill" variant="primary" class="mr-2" />
        <span>Inadimplência</span>
      </div>

      <!-- Filtro de Período -->
      <FiltroPeriodo
        class="mt-4"
        :value="periodo"
        default-label="Hoje"
        :auto-apply-on-mount="!ignoreInitialApply"
        @apply="onApplyPeriodo"
      />
    </b-card-title>

    <b-card-body class="pl-6 pb-4 pt-3 d-flex align-items-end mb-2">
      <!-- LOADING -->
      <template v-if="loading">
        <b-skeleton width="40%" height="36px" class="mr-3" />
        <b-skeleton width="80px" height="24px" />
      </template>

      <!-- CONTEÚDO -->
      <template v-else>
        <h2
          class="display-4 text-danger mb-0 font-weight-bold"
          style="line-height: 1.6rem"
        >
          {{ toCurrency(inadimplencia.valor) }}
        </h2>
        <span class="ml-4 badge" :class="percentualBadgeClass">
          {{ formatPercent(inadimplencia.percentual) }}
        </span>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import FiltroPeriodo from "./FiltroPeriodo.vue";

export default {
  name: "Inadimplencia",
  components: { FiltroPeriodo },
  props: {
    // valores vindos do back
    inadimplencia: {}, // ex.: 45000.12

    // período atual (opcional): { inicio: 'YYYY-MM-DD', fim: 'YYYY-MM-DD' } ou null
    periodo: { type: Object, default: null },

    // estado de carregamento
    loading: { type: Boolean, default: false },

    // não emitir @apply no boot (mantém silencioso no F5)
    ignoreInitialApply: { type: Boolean, default: true },
  },

  computed: {
    valorTotalNumber() {
      const n = Number(String(this.inadimplencia.valor).replace(",", "."));
      return Number.isFinite(n) ? n : 0;
    },
    percentualNumber() {
      const n = Number(String(this.inadimplencia.percentual).replace(",", "."));
      return Number.isFinite(n) ? n : 0;
    },
    percentualBadgeClass() {
      // > 10% danger, senão warning
      return this.percentualNumber > 10 ? "badge-danger" : "badge-warning";
    },
  },

  methods: {
    onApplyPeriodo({ inicio, fim }) {
      this.$emit("change-periodo", { inicio, fim });
    },
    toCurrency(value) {
      try {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(value ?? 0);
      } catch {
        const num = Number(value ?? 0)
          .toFixed(2)
          .replace(".", ",");
        return `R$ ${num}`;
      }
    },
    // Simples: troca ponto por vírgula e acrescenta '%'
    formatPercent(v) {
      if (v === null || v === undefined || v === "") return "0%";
      return `${String(v).replace(".", ",")}%`;
    },
  },
};
</script>

<style scoped>
.display-4 {
  line-height: 1.1;
}
</style>
